import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';

import {
  setMaintenanceMode,
  setServerError,
} from '@/redux/reducers/userReducer';

import { type ErrorPayload } from '../lib/getErrorMessage';

const errorStatus = [500, 502];
const errorMessage = ['Network Error'];

const toNumeric = (status: number | string | undefined): number | null => {
  if (!status) return null;
  const n = typeof status === 'string' ? parseInt(status, 10) : status;

  return isNaN(n) ? null : n;
};

const checkStatus = (status: number | string | undefined): boolean => {
  const n = toNumeric(status);

  return n !== null && errorStatus.includes(n);
};

const isMaintenance = (status: number | string | undefined): boolean => {
  return toNumeric(status) === 503;
};

export const errorServerMiddleware: Middleware =
  (api) => (next) => (action: unknown) => {
    if (isRejectedWithValue(action)) {
      const { status, requestId, data, message } =
        action.payload as ErrorPayload;
      const reqId = data && Object.keys(data) ? data.requestId : requestId;

      if (isMaintenance(status)) {
        api.dispatch(setMaintenanceMode(data?.wakeUpAt ?? null));
      } else if (errorMessage.includes(message)) {
        api.dispatch(setServerError(reqId || '500'));
      } else if (checkStatus(status)) {
        api.dispatch(setServerError(reqId || '500'));
      }
    }

    return next(action);
  };
